import { OfferLetter } from '@app/models/offer-letters/offer-letter.model';
import { BadgeColumn } from '@app/modules/table/classes/badge-column.class';
import { CellDisplay } from '@app/modules/table/enums/cell-display.enum';
import { BadgeDisplay } from '@app/modules/table/interfaces/badge-display.interface';

export class SignatureStatusColumn extends BadgeColumn<OfferLetter> {
    title = 'table.offer-letter.signatureStatus';
    type: CellDisplay = CellDisplay.badge;

    getBadgeDisplay(offerLetter: OfferLetter): BadgeDisplay | undefined {
        if (offerLetter.isSigned()) {
            return {
                type: 'success',
                label: 'offer-letter.signed',
            };
        }

        return {
            type: 'default',
            label: 'offer-letter.notSigned',
        };
    }
}
